var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('silent-box',{staticClass:"display-pictures container-fluid",attrs:{"gallery":_vm.formatedPictures,"image-class":"col-3 col-md-2 row"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }